"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ProductTileActions;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _domainSearch = _interopRequireDefault(require("@site/pattern-library-core/domain-search"));
var _merchButton = require("@site/pattern-library-core/merch-button");
var _price = _interopRequireDefault(require("@site/pattern-library-core/price"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = _interopRequireDefault(require("react"));
var _planBoxModal = _interopRequireDefault(require("../../../../page-body/sections/plan-box-modal"));
/* VENDOR */

/* LOCAL */

const ActionsContainer = /*#__PURE__*/(0, _react.styled)("div")({
  name: "ActionsContainer",
  class: "pl-a170yubr",
  vars: {
    "a170yubr-0": [({
      justifyContent
    }) => justifyContent]
  }
});
const ButtonContainer = /*#__PURE__*/(0, _react.styled)("div")({
  name: "ButtonContainer",
  class: "pl-b1ib4nsq"
});
const PriceLockupContainer = /*#__PURE__*/(0, _react.styled)("div")({
  name: "PriceLockupContainer",
  class: "pl-p94ma5s"
});

/**
 * Render Actions.
 * @memberof module:ProductTile
 *
 * @param {string} actionsLayout The actions layout to render
 * @param {object} cta CTA object to render
 * @param {object} priceLockup Price lockup
 * @returns {React.ReactElement} Actions component
 * @public
 */
function ProductTileActions({
  actionsLayout,
  cta,
  priceLockup,
  planbox,
  modalCloseAriaLabel,
  modalRetryText,
  gridIndex,
  trackingCustomProperties = {}
}) {
  // Set default values for price lockup and domain search within product tile
  priceLockup && (priceLockup.headlineSize = 'h6');
  if (actionsLayout === 'domain-search' && cta) {
    cta.height = 'small';
  }
  trackingCustomProperties.plp_order = gridIndex;
  switch (actionsLayout) {
    case 'button':
      return /*#__PURE__*/_react2.default.createElement(ActionsContainer, {
        justifyContent: "end",
        "data-cy": "actions-container"
      }, /*#__PURE__*/_react2.default.createElement(ButtonContainer, null, /*#__PURE__*/_react2.default.createElement(_merchButton.NSMerchButton, (0, _extends2.default)({
        isPromo: false
      }, cta, {
        trackingCustomProperties: trackingCustomProperties
      }))));
    case 'domain-search':
      return /*#__PURE__*/_react2.default.createElement(ActionsContainer, {
        justifyContent: "strech",
        "data-cy": "actions-container"
      }, /*#__PURE__*/_react2.default.createElement(_domainSearch.default, (0, _extends2.default)({
        isPromo: false
      }, cta, {
        trackingCustomProperties: trackingCustomProperties
      })));
    case 'price-lockup-and-button':
      return /*#__PURE__*/_react2.default.createElement(ActionsContainer, {
        justifyContent: "space-between",
        "data-cy": "actions-container"
      }, /*#__PURE__*/_react2.default.createElement(PriceLockupContainer, null, /*#__PURE__*/_react2.default.createElement(_price.default, priceLockup)), /*#__PURE__*/_react2.default.createElement(ButtonContainer, null, /*#__PURE__*/_react2.default.createElement(_merchButton.NSMerchButton, (0, _extends2.default)({
        isPromo: false
      }, cta, {
        trackingCustomProperties: trackingCustomProperties
      }))));
    case 'planbox-modal':
      return /*#__PURE__*/_react2.default.createElement(ActionsContainer, {
        justifyContent: "space-between",
        "data-cy": "actions-container"
      }, /*#__PURE__*/_react2.default.createElement(PriceLockupContainer, null, /*#__PURE__*/_react2.default.createElement(_price.default, priceLockup)), /*#__PURE__*/_react2.default.createElement(_planBoxModal.default, {
        cta: cta,
        planbox: planbox,
        modalCloseAriaLabel: modalCloseAriaLabel,
        retryText: modalRetryText
      }));
    case `none`:
    default:
      return null;
  }
}
ProductTileActions.propTypes = {
  actionsLayout: _propTypes.default.oneOf(['button', 'domain-search', 'price-lockup-and-button', 'planbox-modal', 'none']).isRequired,
  cta: _propTypes.default.oneOfType([_propTypes.default.shape(_merchButton.NSMerchButton.propTypes), _propTypes.default.shape(_domainSearch.default.propTypes)]).isRequired,
  priceLockup: _propTypes.default.shape(_price.default.propTypes),
  planbox: _propTypes.default.object,
  modalCloseAriaLabel: _propTypes.default.string,
  modalRetryText: _propTypes.default.string,
  gridIndex: _propTypes.default.number,
  trackingCustomProperties: _propTypes.default.object
};